<template>
  <div class="toast-container p-3">
    <div v-for="(item, i) in messages" :key="i" :ref="`toastContent_${i}`" class="toast" :class="`border-${item.variant}`" role="alert" aria-live="assertive" aria-atomic="true">
      <!-- <div class="toast-header"> -->
        <!-- <img src="..." class="rounded me-2" alt="..."> -->
        <!-- <strong class="me-auto">Bootstrap</strong>
        <small>11 mins ago</small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button> -->
      <!-- </div> -->
      <div class="toast-body" :class="`text-${item.variant}`">
        {{ item.data.message }}
      </div>
    </div>
  </div>
</template>

<script>
import bootstrap from "bootstrap/dist/js/bootstrap";

export default {
  data(){
    return {
      messages: []
    }
  },

  mounted() {
    this.$store.commit('toast/listen', (data) => {
      this.messages.push(data);
      let index = this.messages.length - 1;

      window.setTimeout(() => {
        let toast = new bootstrap.Toast(this.$refs['toastContent_' + index], {
          delay: data.delay
        });
        toast.show();

        // toast._element.addEventListener('hidden.bs.toast', () => {
        //   this.messages.splice(index, 1);
        // });
      });
    });
  }
}
</script>